import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger'
import _ from 'lodash';

import modules from './modules';
import lookups from "./modules/lookups/index.js";
import queryBuilderModules from './modules/coding-queries/index.js';
import adminModules from './modules/coding-admin/index.js';
import codingUiModules from './modules/coding-ui/index.js'
import userPermissionsModules from "./modules/coding-user-permissions/index.js";
import booleanSearchModules from "./modules/boolean-search/index.js";
import outletsModules from "./modules/outlets/index.js";
import queryRulesModules from "./modules/query-rules/index.js"
import aclModules from './modules/acl/index.js';
import usersModules from './modules/users/index.js';
import insightUsersModules from './modules/insight-users/index.js';
import carmaAiModules from './modules/carma-ai/index.js';
import influencerGroups from './modules/influencerGroups.js';
import { ENVIRONMENT } from '@/config/app-const';

Vue.use(Vuex);
const debug = ENVIRONMENT !== 'production';

const state = {
  user: JSON.parse(localStorage.getItem('projectcode-user')) || {},
  isInsight: false,
  insightSessionToken: null
}

const mutations = {
  SET_INSIGHT_FLAG(state, payload) {
    state.isInsight = payload
  },
  SET_INSIGHT_SESSION_TOKEN(state, payload) {
    state.insightSessionToken = payload
  }
}

export default new Vuex.Store({
  state,
  getters: {
    isLoggedIn: () => {
      if(state.isInsight) return true
      const userInfo = JSON.parse(localStorage.getItem('projectcode-user'));
      return !!userInfo && !_.isEmpty(userInfo)
    },
    accessToken: (state) => {
      return state.user.user.data && state.user.user.data.accessToken;
    }
    // isAdmin: (state) => {
    //   return state.user.user.data != null && state.user.user.data.code_admin == true;
    // }
    // isLoggedIn: () => true
  },
  mutations,
  modules: {
    ...modules,
    lookups: {
      modules: lookups,
    },
    queryBuilder: {
      namespaced: true,
      modules: queryBuilderModules
    },
    rulesEngine: {
      namespaced: true,
      modules: queryRulesModules
    },
    admin: {
      namespaced: true,
      modules: adminModules
    },
    // userPermissions: {
    //   namespaced: true,
    //   modules: userPermissionsModules
    // },
    ...userPermissionsModules,
    ...codingUiModules,
    ...booleanSearchModules,
    ...outletsModules,
    ...aclModules,
    ...usersModules,
    ...insightUsersModules,
    ...carmaAiModules,
    influencerGroups
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
});